module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qpelv1-76f7c0780b50757115221285f79ab1d4.jpg";